/******************
// directive: scrollableContents
*************/
angular.module('app')
        .controller('scrollableContentsCtrl', scrollableContentsCtrl)
        .directive('scrollableContents', scrollableContents);

    scrollableContentsCtrl.$inject = ['$scope', '$timeout'];
    function scrollableContentsCtrl($scope, $timeout) {
        const ctrl = this;
        ctrl.currentSection = 1;
        ctrl.totalSections = 0;
        ctrl.scrollableContentsContainer = null;
        ctrl.scrollableItems = null;
        ctrl.itemsWithExtraSlides = [];
        ctrl.footer = null;

        ctrl.isMobile = window.matchMedia("only screen and (max-width: 1023px)").matches;
        ctrl.isSmallDesktop = window.matchMedia("only screen and (min-width: 1024px) and (max-width: 1549px)").matches;

        let withExtraSlides = null;
        let canScroll = true;
        ctrl.scrollSection = function (index, nextIndex, direction) {
            var header = angular.element('.header');
            var dropdown = header.find('.dropdown');
            if (dropdown.hasClass('active')) {
                return false;
            }

            //ctrl.setArrowVisibility(false);
            ctrl.setFooterVisibility(false);

            if (!canScroll) {
                return false;
            }
            canScroll = false;
            //this prevents continuous scrolling especially for trackpad
            $timeout(function () {
                canScroll = true;
            }, 700);


            if (withExtraSlides === null || withExtraSlides === undefined) {
                withExtraSlides = ctrl.itemsWithExtraSlides.find(function (element) {
                    return element.contentIndex === nextIndex;
                });
            }

            if (withExtraSlides) { //content with extra slides
                const fpNav = angular.element('#fp-nav');

                if (!withExtraSlides.started) {
                    ctrl.currentSection = nextIndex;                    
                    $scope.$broadcast('animate', { index: nextIndex });
                    //fpNav.css({ display: 'none' });
                    new TimelineMax()
                           .to(fpNav, 0.25, { opacity: 0, display: 'none', ease: Power4.easeInOut })
                    withExtraSlides.started = true;
                }
                else {
                    if ((withExtraSlides.currentIndex === 1 && direction === 'up') ||
                        (withExtraSlides.currentIndex === withExtraSlides.totalSections && direction === 'down')) {
                        ctrl.currentSection = nextIndex;

                        //reset service nav of child sliders
                        $scope.$broadcast('resetNavigation', { lastIndex: withExtraSlides.currentIndex });

                        $scope.$broadcast('animate', { index: nextIndex });

                        withExtraSlides.currentIndex = 1;
                        withExtraSlides.started = false;
                        withExtraSlides = null;
                        //fpNav.css({ display: 'block' });
                        new TimelineMax()
                           .to(fpNav, 0.25, { opacity: 1, display: 'block', ease: Power4.easeInOut })
                    }
                    else {
                        fpNav.css({ display: 'none' });
                        const scrollDir = direction === 'up' ? -1 : 1;
                        $scope.$broadcast('animateNextSlide', { contentIndex: ctrl.currentSection, scrollDir: scrollDir });
                        return false;
                    }
                }   
            }
            else {
                $scope.$broadcast('pauseAnimation', { index: index });
                ctrl.currentSection = nextIndex;
                $scope.$broadcast('animate', { index: nextIndex });
            }
        }

        ctrl.includeSectionHasExtraSlides = function (slideInfo) {
            ctrl.itemsWithExtraSlides.push(slideInfo);
        }

        ctrl.setArrowVisibility = function (visible) {
            /*if (ctrl.currentSection !== ctrl.totalSections) {
                $scope.$broadcast('setArrowVisibility', { visible: visible });
            }*/
            $scope.$broadcast('setArrowVisibility', { visible: visible });
        }

        ctrl.setFooterVisibility = function (visible) {

            if (!visible) {
                if (ctrl.footer.is(':visible')) {
                    new TimelineMax().to(ctrl.footer, 1, { opacity: 0, display: 'none' });
                }
            }
            else {
                ctrl.setFooterPosition();
                new TimelineMax().to(ctrl.footer, 1, { opacity: 1, display: 'block' });
            }
        }

        ctrl.setFooterPosition = function () {
            //const containerHeight = angular.element(ctrl.scrollableItems[0]).height();
            //ctrl.footer.css({ top: ((ctrl.currentSection * containerHeight) - 130) + 'px' });
        }

        ctrl.hideMainNav = function () {
            const fpNav = angular.element('#fp-nav');
            new TimelineMax()
                .to(fpNav, 0.25, { opacity: 0, display: 'none', ease: Power4.easeInOut })
        }
    }

    scrollableContents.$inject = ['$timeout', '$window']
    function scrollableContents($timeout, $window) {
        return {
            restrict: 'EA',
            link: link,
            controller: scrollableContentsCtrl
        }

        function link(scope, element, attrs, ctrl) {
            ctrl.scrollableContentsContainer = angular.element(element);
            ctrl.scrollableItems = ctrl.scrollableContentsContainer.find('.section');
            ctrl.totalSections = ctrl.scrollableItems.length;
            ctrl.footer = angular.element('.footer-scrollable-content');

            angular.element(element).fullpage({
                anchors: JSON.parse(attrs.pages),
                navigation: true,
                autoScrolling: true,
                verticalCentered: false,
                fitToSection: true,
                onLeave: ctrl.scrollSection,
                css3: false
            });

            //initialize first animation
            scope.$broadcast('animate', { index: ctrl.currentSection });

            angular.element($window).on('resize', function () {
                $timeout(function () {
                    ctrl.setFooterPosition();
                }, 700);
            });
        }    
    }

/******************
// directive: scrollableItem
*************/
angular.module('app')
    .controller('scrollableItemCtrl', scrollableItemCtrl)
    .directive('scrollableItem', scrollableItem);

scrollableItemCtrl.$inject = ['$scope'];
function scrollableItemCtrl($scope) {
    const ctrl = this;
    ctrl.contentIndex = $scope.contentIndex;
}
function scrollableItem() {
    return {
        restrict: 'EA',
        require: '^^scrollableContents',
        scope: {
            contentIndex: '@'
        },
        controller: scrollableItemCtrl
    }
}


/******************
// directive: scrollableArrow
*************/
angular.module('app')
    .directive('scrollableArrow', scrollableArrow)
scrollableArrow.$inject = ['$window', '$timeout']
function scrollableArrow($window, $timeout) {
    return {
        restrict: 'E',
        require: {
            scrollableContents: '^^scrollableContents'
        },
        link: link,
        template: '<a class="scroll-arrow"></a>'
    }

    function link(scope, element, attrs, ctrl) {
        const container = angular.element(element);
        const duration = 2;

        const tweenArrow = new TimelineMax({ repeat: -1, repeatDelay: 0 })
                .set(element, { y: 0 })
                .to(element, duration / 4, { y: +20, ease: Power2.easeOut }, "bounceme")
                .to(element, duration / 2, { y: 0, ease: Power2.easeOut, delay: duration / 4 }, "bounceme")
                .pause();


        container.find('.scroll-arrow').on('click', function () {
            $.fn.fullpage.moveSectionDown();
        });

        function setArrowPosition() {
            const containerHeight = angular.element(ctrl.scrollableContents.scrollableItems[0]).height();
            container.css({ top: ((ctrl.scrollableContents.currentSection * containerHeight) - 80) + 'px' });
        }

        scope.$on('setArrowVisibility', function (event, args) {
            setArrowPosition();
            if (args.visible) {
                container.css({ opacity: 1, display: 'block' });
                tweenArrow.play();
            }
            else {
                tweenArrow.pause();
                container.css({ opacity: 0, display: 'none' });
            }
        });

        angular.element($window).on('resize', function () {
            $timeout(function () {
                setArrowPosition();
            }, 700)
        })
    }
}